import {useEffect} from 'react'

const useLegacyJs = (): void => {
  useEffect(() => {
    async function init() {
      if (!window.location.pathname.includes('/online-whiteboard/')) {
        const wistiaVideos = await import('../components/scripts/wistia-videos.legacy')
        wistiaVideos.default.init()
      }

      const templatesOpener = await import('../components/scripts/templates-opener.legacy')
      templatesOpener.default.init()
    }

    init()
  }, [])
}

export default useLegacyJs
